(() => {
  function init(root) {
    if (root.dataset.poloReady) return;
    const track = root.querySelector('[data-polo-track]');
    const looks = [...track.querySelectorAll('[data-pvg-card]')];
    const count = looks.length, add = root.querySelector('[data-polo-add]');
    if (!count || !add) return;
    root.dataset.poloReady = 'true';
    const controller = new AbortController(), signal = controller.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const details = root.querySelector('.skull-polo-selection__details');
    const dotsRoot = root.querySelector('[data-polo-dots]');
    const mod = value => ((value % count) + count) % count;
    const wrap = value => mod(value + count / 2) - count / 2;
    let position = Math.min(2, count - 1), goal = position, velocity = 0;
    let frame = 0, paintFrame = 0, selected = -1, stride = 100;
    let gesture = null, suppressClick = false, clickTimer = 0, wheelTimer = 0, detailAnimation;
    const dots = looks.map((look, index) => {
      look.setAttribute('aria-hidden', 'true');
      look.dataset.poloIndex = index;
      const image = look.querySelector('img');
      image.loading = 'eager';image.fetchPriority = 'low';image.decode().catch(() => {});
      const dot = document.createElement('button');
      dot.type = 'button';dot.className = 'skull-polo-dot';dot.setAttribute('aria-label', look.dataset.color);
      dot.addEventListener('click', () => goLogical(index), {signal});
      dotsRoot.append(dot);
      return dot;
    });
    function select(index) {
      const look = looks[index], available = look.dataset.poloAvailable !== 'false';
      for (const key of ['productHandle','color','title','price','image']) add.dataset[key] = look.dataset[key];
      add.disabled = !available;
      add.setAttribute('aria-disabled', String(!available));
      if (selected === index) return;
      const initial = selected < 0;
      selected = index;
      root.querySelector('[data-polo-color]').textContent = look.dataset.color;
      root.querySelector('[data-polo-price]').textContent=look.dataset.price;
      dots.forEach((dot, i) => {dot.setAttribute('aria-pressed', String(i === index));dot.toggleAttribute('data-active', i === index);});
      if (!initial && !reduced.matches) {
        detailAnimation?.cancel();
        detailAnimation = details.animate([{opacity:.35,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}], {duration:170,easing:'ease-out'});
      }
    }
    function paint() {
      paintFrame = 0;
      const active = mod(Math.round(position));
      for (const [index, look] of looks.entries()) {
        const distance = wrap(index - position), depth = Math.min(3, Math.abs(distance));
        look.style.setProperty('--polo-x', `${distance * stride}px`);
        look.style.setProperty('--polo-scale', String(Math.max(.57, 1 - depth * .19)));
        look.style.setProperty('--polo-angle', `${Math.max(-2, Math.min(2, distance)) * -5}deg`);
        look.style.setProperty('--polo-blur', `${Math.min(1.4, depth * .65)}px`);
        look.style.setProperty('--polo-layer', String(100 - Math.round(Math.abs(distance) * 20)));
        look.toggleAttribute('data-polo-active', index === active);
        look.tabIndex = index === active ? 0 : -1;
        look.setAttribute('aria-hidden', String(index !== active));
        const badge = look.querySelector('.skull-polo-soldout');
        if (badge) badge.hidden = look.dataset.poloAvailable !== 'false';
      }
      select(active);
    }
    function stop() {cancelAnimationFrame(frame);frame = 0;}
    function animateTo(target, initialVelocity = 0) {
      stop();goal = target;velocity = initialVelocity;
      if (reduced.matches) {position = goal;velocity = 0;paint();return;}
      let last = performance.now(), began = last;
      function tick(now) {
        const dt = Math.max(1, Math.min(32, now - last));last = now;
        velocity += ((goal - position) * .00018 - velocity * .028) * dt;
        position += velocity * dt;
        if ((Math.abs(goal - position) < .0005 && Math.abs(velocity) < .00003) || now - began > 950) {
          position = goal;velocity = 0;frame = 0;paint();return;
        }
        paint();frame = requestAnimationFrame(tick);
      }
      frame = requestAnimationFrame(tick);
    }
    function goLogical(index) {const nearest = Math.round(position);animateTo(nearest + wrap(index - mod(nearest)), velocity);}
    root.querySelector('[data-polo-prev]').addEventListener('click', () => animateTo(Math.round(frame ? goal : position) - 1, velocity), {signal});
    root.querySelector('[data-polo-next]').addEventListener('click', () => animateTo(Math.round(frame ? goal : position) + 1, velocity), {signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') goLogical(event.key === 'Home' ? 0 : count - 1);
      else animateTo(Math.round(frame ? goal : position) + (event.key === 'ArrowRight' ? 1 : -1), velocity);
    }, {signal});
    track.addEventListener('pointerdown', event => {
      if (event.button !== 0 || gesture) return;
      stop();clearTimeout(wheelTimer);velocity = 0;
      gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,base:position,lastX:event.clientX,time:performance.now(),speed:0,moved:false};
    }, {signal});
    track.addEventListener('pointermove', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (!gesture.moved) {
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 7) {gesture = null;return;}
        if (Math.abs(dx) < 6) return;
        gesture.moved = true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');
      }
      const now = performance.now(), dt = Math.max(8, now - gesture.time);
      const speed = -(event.clientX - gesture.lastX) / stride / dt;
      gesture.speed = gesture.speed * .5 + speed * .5;
      gesture.lastX = event.clientX;gesture.time = now;
      position = gesture.base - dx / stride;goal = position;
      event.preventDefault();
      if (!paintFrame) paintFrame = requestAnimationFrame(paint);
    }, {signal});
    function release(event) {
      if (!gesture || event.pointerId !== gesture.id) return;
      const current = gesture;gesture = null;track.classList.remove('is-dragging');
      if (!current.moved) {animateTo(Math.round(position));return;}
      suppressClick = true;clearTimeout(clickTimer);clickTimer = setTimeout(() => {suppressClick = false;}, 350);
      const speed = Math.max(-.012, Math.min(.012, current.speed));
      const projected = position + Math.max(-1.4, Math.min(1.4, speed * 150));
      animateTo(Math.round(projected), speed);
    }
    track.addEventListener('pointerup', release, {signal});
    track.addEventListener('pointercancel', release, {signal});
    track.addEventListener('wheel', event => {
      if (event.ctrlKey || (!event.shiftKey && Math.abs(event.deltaX) <= Math.abs(event.deltaY))) return;
      event.preventDefault();stop();
      const amount = event.shiftKey ? event.deltaY : event.deltaX;
      position += amount * (event.deltaMode === 1 ? 16 : 1) / stride;goal = position;velocity = 0;paint();
      clearTimeout(wheelTimer);wheelTimer = setTimeout(() => animateTo(Math.round(position)), 110);
    }, {signal,passive:false});
    track.addEventListener('dragstart', event => event.preventDefault(), {signal});
    track.addEventListener('click', event => {
      if (suppressClick) {event.preventDefault();event.stopPropagation();suppressClick = false;}
    }, {signal,capture:true});
    const resize = new ResizeObserver(() => {
      stride = Math.max(looks[0].offsetWidth - parseFloat(getComputedStyle(root).getPropertyValue('--polo-overlap')), (track.clientWidth + looks[0].offsetWidth * .75) / count);
      paint();
    });
    resize.observe(track);
    reduced.addEventListener('change', () => {if (reduced.matches) animateTo(Math.round(goal));}, {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      stop();cancelAnimationFrame(paintFrame);clearTimeout(clickTimer);clearTimeout(wheelTimer);resize.disconnect();detailAnimation?.cancel();controller.abort();delete root.dataset.poloReady;
    }, {signal});
    stride = Math.max(looks[0].offsetWidth - parseFloat(getComputedStyle(root).getPropertyValue('--polo-overlap')), (track.clientWidth + looks[0].offsetWidth * .75) / count);
    paint();
  }
  document.querySelectorAll('[data-polo-showcase]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-polo-showcase]').forEach(init));
})();
